import React, { useContext } from "react";
import { IGateway } from "@grabcad/company-server-shared/dist/types";

import WarningSvg from "../../../../../../images/gateways/warning.svg";
import HealthySvg from "../../../../../../images/gateways/healthy.svg"; // Update to the correct icon
import NewSvg from "../../../../../../images/gateways/new.svg"; // Update to the correct icon

import { Badge, BadgeIcon, BadgeText } from "./StatusBadge.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";

type GatewayStatus = IGateway["status"];

interface StatusBadgeProps {
    status: GatewayStatus;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const { t } = useContext(ApplicationContext);

    const STATUS_CONFIG: Record<
        GatewayStatus,
        {
            label: string;
            icon: string;
        }
    > = {
        HEALTHY: {
            label: t("devices.gateways.gateway_card.healthy"),
            icon: HealthySvg,
        },
        UNHEALTHY: {
            label: t("devices.gateways.gateway_card.unhealthy"),
            icon: WarningSvg,
        },
        NEW: {
            label: t("devices.gateways.gateway_card.new"),
            icon: NewSvg,
        },
    };
    const { label, icon } = STATUS_CONFIG[status];

    return (
        <Badge status={status}>
            <BadgeIcon src={icon} alt={label} />
            <BadgeText status={status}>{label}</BadgeText>
        </Badge>
    );
};

export default StatusBadge;
